angular.module('impactx.rfxsupplier').component('ixRfxSupplierOfferDetails', {
        bindings: {
            data: '=',
            trns: '<',
            conversationFunction: "&",
            changeSupplierFunction: "&"
        },
        controller: 'RFXSupplierOfferDetailsCtrl',
        templateUrl: 'modules/rfxsupplier/templates/rfx-supplier-offer-details.html'
    }
);